import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpService } from './http.service';
import { StorageService } from './storage.service';
import { CommonService } from './common.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class UserService {
    private url: string = environment.base_url;

    constructor(
        private httpService: HttpService,
        private storageService: StorageService,
        protected commonService: CommonService
    ) {
    }

    save(token: string, data: string): void {
        this.storageService.set('userToken', token);
        this.storageService.set('userData', data);
    }

    delete(): void {
        this.deleteToken();
        this.deleteData();
        this.deleteCompany();
        // this.commonService.removeRedirectTo();
    }

    lock(): void {
        this.deleteToken();
    }

    getToken() {
        return this.storageService.get('userToken');
    }

    getTokenNBFTime() {
        if (!this.getToken()) {
            return false;
        }
        try {
            const base64Url = this.getToken().split('.')[1];
            const base64 = base64Url.replace('-', '+').replace('_', '/');
            const parsed = JSON.parse(window.atob(base64));
            if (parsed.renew_after) {
                return parsed.renew_after;
            }
        } catch (e) {
            return false;
        }
        return false;
    }

    deleteToken(): void {
        this.storageService.delete('userToken');
    }

    getData() {
        return this.storageService.get('userData') ? JSON.parse(this.storageService.get('userData')) : false;
    }

    deleteData(): void {
        this.storageService.delete('userData');
    }

    getCompanies() {
        return (this.getData().company_profiles['data'].length > 0) ? this.getData().company_profiles['data'] : [];
    }

    getCompany() {
        return this.storageService.get('userCompany') ? JSON.parse(this.storageService.get('userCompany')) : false;
    }

    setCompany(company: string): void {
        this.storageService.set('userCompany', company);
    }

    deleteCompany(): void {
        this.storageService.delete('userCompany');
    }

    getEmployeeProfile() {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.getCompany()['id']);
        return this.httpService.get(this.url + '/b2b/profile', httpParams).map(resp => resp);
    }

    employeeProfileChangeRequest(message: any) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.getCompany()['id']);
        const payload = { message : message };
        return this.httpService.post(this.url + '/b2b/profile/request_change', payload, httpParams).map(resp => resp);
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/user.service.ts